$(document).ready(function(){
$('.Popover__Value').click(function(){
  var Pricevariant = $(this).find('.price-variant').text();
  $('.updatePrice').text(Pricevariant);
  var dataPrice = $(this).find('.items-box').attr('data-price');
  if(dataPrice > 50){
    $('.freeShipping').show();
    // $('.noShipping').hide();
  }else{
    $('.freeShipping').hide();
    // $('.noShipping').show();
  }
});
  var dataPrice = $('.Popover__Value.is-selected').find('.items-box').attr('data-price');
  if(dataPrice > 50){
    $('.freeShipping').show();
    // $('.noShipping').hide();
  }else{
    $('.freeShipping').hide();
    // $('.noShipping').show();
  }
$(document).on('click','.SectionHeader__TabList .TabList__Item', function(){
  var src = $(this).attr('data-src'); 
  $('.tablist_viewall').attr('href',src);
});

$(document).on('click', '.ShopTheLook__Dot', function(){
      if (window.matchMedia('(min-width: 1008px)').matches) {
        $('.ShopTheLook__ProductList').css('opacity', '1');
        $('.ShopTheLook__ProductList').css('visibility', 'visible');
      }
    });

$(document).on('click','.buynow-btn', function(e) {
  e.preventDefault();
     var ID = $(this).attr("data-var_id");
     var Qty = 1;
     // console.log(' Qty ' + 1 + 'ID'+ ID );
     buyItemToCart(ID, Qty);
});

function buyItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(getCheckout) {
      window.location= ("./checkout");
        },
    error: function(error) {
      console.log(error);
    }
  }); 
};
});

//In Footer content block Add Read more Or Read less 
let read_more = document.getElementById('read-more')
let read_less = document.getElementById('read-less');
let truncated_content = document.getElementById('truncated-footer_content');
let full_content = document.getElementById('footer_content');

read_more.addEventListener('click', showHideDescription)
read_less.addEventListener('click', showHideDescription)

function showHideDescription(){
  let ID = this.id
  if(ID === "read-more"){
    truncated_content.style.display = "none";
    full_content.style.display = "block";
  }else {
    truncated_content.style.display = "block";
    full_content.style.display = "none";    
  }
}
// $(document).on('click','.moreless-button', function(){
//   $('.footer_moretext').slideToggle();
//   if ($('.moreless-button').text() == "Read more") {
//     $(this).text("Read less")
//   } else {
//     $(this).text("Read more")
//   }
// });
$(document).ready(function(){
  if($(window).width() < 991){
  $(".logolist-slider").slick({
      dots: false,
      infinite: true,
      autoplay:true,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed:5000,
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: false,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 8 14" fill="none"><path d="M7 13L1 7L7 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
       
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              centerMode: false,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              centerMode: false,
              slidesToScroll: 1
            }
          },
           {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
    });
  }
    $('.Product_sli_main').slick({
  dots: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay:false,
  prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 8 14" fill="none"><path d="M7 13L1 7L7 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    }
  ]
});




// $('.readmore.itg--description-read').click(function (event) {
//   event.preventDefault();
//   var descriptionFull = document.querySelector('.product-description-full');
//   descriptionFull.style.display = 'block';
//   var descriptionShort = document.querySelector('.product-description-short');
//   descriptionShort.style.display = 'none';
// });
// $('.readless.itg--description-read').click(function (event) {
//   event.preventDefault();
//   var descriptionFull = document.querySelector('.product-description-full');
//   descriptionFull.style.display = 'none';
//   var descriptionShort = document.querySelector('.product-description-short');
//   descriptionShort.style.display = 'block';
// });  


  $(document).on('click', '.cstm_search_bar input', function(){
    $('#Search.Search').attr('aria-hidden', 'false');
  });
   

});





$(document).ready(function(){
     $('.readmore').insertAfter( '.product-description' );

        $('.readmore').click(function (event) {
          event.preventDefault();
          var description = document.querySelector('.product-description');
          console.log(description.style.height)
          if (description.style.height === ''){
            description.style.height = 'auto';
          } else if (description.style.height === 'auto'){
            description.style.height = '';
          }
          else{
            description.style.height = '92px';
          }

          $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
        });
});
 $(document).ready(function(){
       
        $('.itg--additional-ingredient-content .mobilereadmore').click(function (event) {
          event.preventDefault();
          var description = document.querySelector('.itg--additional-ingredient-content p.onmobile_additional');
          console.log(description.style.height)
          if (description.style.height === ''){
            description.style.height = 'auto';
          } else if (description.style.height === 'auto'){
            description.style.height = '';
          }
          else{
            description.style.height = '92px';
          }

          $(this).text($(this).text() == 'Read less' ? 'Read more' : 'Read less');
        });
    });
$(document).ready(function(){
        
        $('.itg--additional-faq-content .mobilereadmore').click(function (event) {
          event.preventDefault();
          var description = document.querySelector('.itg--additional-faq-content p.onmobile_additional');
          console.log(description.style.height)
          if (description.style.height === ''){
            description.style.height = 'auto';
          } else if (description.style.height === 'auto'){
            description.style.height = '';
          }
          else{
            description.style.height = '92px';
          }

          $(this).text($(this).text() == 'Read less' ? 'Read more' : 'Read less');
        });
});

$(document).ready(function(){
        
        $('.itg--additional-faq-content span.ondesktop_additional').click(function (event) {
          event.preventDefault();
          var description = document.querySelector('.itg--additional-faq-content p.ondesktop_additional ');
          console.log(description.style.height)
          if (description.style.height === ''){
            description.style.height = 'auto';
          } else if (description.style.height === 'auto'){
            description.style.height = '';
          }
          else{
            description.style.height = '92px';
          }

          $(this).text($(this).text() == 'Read less' ? 'Read more' : 'Read less');
        });

  $('.itg--additional-info-ingredient span.ondesktop_additional').click(function (event) {
          event.preventDefault();
          var description = document.querySelector('.itg--additional-info-ingredient p.ondesktop_additional ');
          console.log(description.style.height)
          if (description.style.height === ''){
            description.style.height = 'auto';
          } else if (description.style.height === 'auto'){
            description.style.height = '';
          }
          else{
            description.style.height = '92px';
          }

          $(this).text($(this).text() == 'Read less' ? 'Read more' : 'Read less');
        });


  $('.multicolumn_more').click(function (event) {
    event.preventDefault();
      var descriptions = document.querySelector('.itg--multicolumn-para');
      console.log(descriptions.style.height);
    
    if(descriptions.style.height === ''){
      descriptions.style.height = 'auto';
    } else if(descriptions.style.height === 'auto'){
      descriptions.style.height = '';
    }
    else{
      descriptions.style.height = '50px';
    }
    $(this).text($(this).text() == 'Read less' ? 'Read more' : 'Read less');
  });

 
$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  

$(".multicolumn--read-more").click(function(){
   $(this).parents('.itg--multicolumn-para').find('.multicolumn_content').hide(200);
   $(this).parents('.itg--multicolumn-para').find('.multicolumn-full_content').show(200);
}); 
$(".multicolumn--read-less").click(function(){
   $(this).parents('.itg--multicolumn-para').find('.multicolumn_content').show(200);
   $(this).parents('.itg--multicolumn-para').find('.multicolumn-full_content').hide(200);
});   

 
// // $('.cstm_search_bar .Search__Close').click(func)show(); 
$('.cstm_search_bar .Search__Close').hide();
$(document).on('keyup','input[name="searchQ"]',function(){
  $('input[name="q"]').click().focus();
  $('input[name="q"]').val($(this).val()).change(); 
  if ( $(this).val().length > 0 ){
     $('.cstm_search_bar .Search__Close').show(); 
    }else{
      $('.cstm_search_bar .Search__Close').hide();
      $('#Search').hide();
    }  
});  
$(document).on('keyup','input[name="q"]',function(){ 
  $('input[name="searchQ"]').val($(this).val()).change();
});

$(document).on('click','.cstm-buynowBtn ',function(){
   $('.shopify-payment-button__more-options').trigger("click");
}); 

  $('.Popover__Value:contains("3 Bottles")').click();
});
